<button
  class="capra-button {{ variant }}"
  [ngClass]="['size-' + size, 'color-' + color, 'location-icon-' + iconLocation]"
  [class.with-icon]="!!icon"
  [disabled]="disabled"
  [type]="type"
  [attr.aria-label]="ariaLabel"
  [attr.data-test]="testSelector || 'capra-button-' + variant"
  [attr.form]="form"
  (click)="onClick($event)"
>
  <capra-icon *ngIf="!!icon" [icon]="icon"></capra-icon>
  {{ text }}
</button>
